export default "__VITE_ASSET__4053662a__"